module.exports = __webpack_public_path__ + "img/payment-failed.9e443038.svg";